import { FC } from 'react';
import { SearchIcon } from './icons';
import { TextFieldVariant } from './enums';

type TextFieldOwnProps = {
  variant?: TextFieldVariant;
};

export type TextFieldProps = TextFieldOwnProps &
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const FloatingTextField: FC<TextFieldProps> = ({ variant, ...props }) => {
  const baseInputClass = `box-border peer
    block w-full h-[44px] bg-grey-light border-transparent
    rounded-md text-base md:text-md placeholder:text-transparent
    border
    hover:[&:not(:focus)]:border-grey-plain
    hover:[&:not(:focus)]:dark:border-grey-plain-dark
    text-grey-main dark:text-white
    focus:border-positive-primary disabled:opacity-50 
    disabled:pointer-events-none bg-grey-light 
    dark:bg-grey-light-dark dark:border-transparent 
    dark:text-neutral-400 dark:focus:ring-neutral-600
    focus:pt-5
    focus:pb-2
    [&:not(:placeholder-shown)]:pt-[21px]
    [&:not(:placeholder-shown)]:pb-[5px]
    autofill:pt-[21px]
    autofill:pb-[5px]
    outline-none`;

  const baseLabelClass = `
    box-border absolute top-0 start-0 
    text-md truncate pointer-events-none transition 
    text-grey-hover  h-full
    ease-in-out duration-100 border border-transparent  
    origin-[0_0] peer-disabled:opacity-50 
    peer-disabled:pointer-events-none
    peer-focus:text-sm
    peer-focus:-translate-y-[9px]
    peer-[&:not(:placeholder-shown)]:text-sm
    peer-[&:not(:placeholder-shown)]:-translate-y-[9px]`;

  if (variant === TextFieldVariant.SEARCH) {
    return (
      <div className="relative box-border">
        <input
          {...props}
          id="hs-floating-gray-input-email"
          className={`${baseInputClass} pl-[41px] pr-[17px] py-[14px]`}
        />
        <SearchIcon
          className="
          absolute top-[15px] start-[17px] 
          text-grey-hover
          peer-hover:text-grey-main peer-hover:dark:text-grey-medium
          peer-focus:text-grey-main peer-focus:dark:text-grey-main-dark
          peer-[&:not(:placeholder-shown)]:text-grey-main peer-[&:not(:placeholder-shown)]:dark:text-grey-main-dark
          "
        />
        <label
          htmlFor="hs-floating-gray-input-email"
          className={`${baseLabelClass} pl-[41px] pr-[17px] py-[14px]`}
        >
          {props.placeholder}
        </label>
      </div>
    );
  }
  return (
    <div className="relative box-border">
      <input
        {...props}
        id="hs-floating-gray-input-email"
        className={`${baseInputClass} px-[17px] py-[14px] `}
      />
      <label
        htmlFor="hs-floating-gray-input-email"
        className={`${baseLabelClass} px-[17px] py-[14px] `}
      >
        {props.placeholder}
      </label>
    </div>
  );
};
